import { handleActions } from 'redux-actions';
import Constants from './constants';
import ISettingsState from './state';

const initialState = {
    focus: 50,
    pause: 10,
    team: ''
} as ISettingsState;

export default handleActions(
    {
        [Constants.SAVE_SETTINGS_PENDING]: (state:ISettingsState) => ({ ...state }),
        [Constants.SAVE_SETTINGS_SUCCESS]: (state:ISettingsState, payload:any ) => ({ ...state, ...payload.settings }),
        [Constants.UPDATE_SETTINGS]: (state:ISettingsState, payload:any ) => ({ ...state, ...payload.settings.settings }),
    },
    initialState,
);


// WEBPACK FOOTER //
// ./src/redux/modules/settings/reducer.ts